const backendUrl =
  process.env.REACT_APP_API_BASE_URL ??
  (process.env.NODE_ENV === 'production'
    ? 'https://app.getisi.ai/api'
    : 'http://localhost:8000/api');
const frontendUrl =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_URL || 'https://app.getisi.ai'
    : 'http://localhost:3000';
const downloadUrl = 'http://localhost:4005';
const env = process.env.NODE_ENV;
const outlookClientId =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_AZURE_CLIENT_ID : null;
const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
// let turnstileSiteKey = '0x4AAAAAACA-XxlU8SGIYrQG';

export const outlookClientID = outlookClientId;
export const backend_url = backendUrl;
export const frontend_url = frontendUrl;
export const download_url = downloadUrl;
export const environment = env;
export const turnstile_site_key = turnstileSiteKey;
